module.exports = "/_next/static/images/550d5304b19ccd2030d17c0a362500f6-rewards-illustration@0.75x.png.webp";